import React from "react"
import { Card, CardContent } from "@mui/material"
import VizHeader from "../VizHeader/VizHeader"
import SettingsIcon from '@mui/icons-material/Settings';
import { Grid } from "@mui/material"
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import { useDispatch } from "react-redux";

export default function AdminCardComponent({ val, ind }) {
	const dispatch = useDispatch();
	const { toggleSettingsBox } = bindActionCreators(Actions, dispatch)

	const onClickCardToggle = (val) => {
		toggleSettingsBox(val + 1)
	}

	return (
		<>
			<Card sx={{ display:'flex',justifyContent:'center',alignItems:'center', cursor: 'pointer',height:{xl:'300px',lg:'300px'}}} onClick={(val) => onClickCardToggle(ind)}>
				<CardContent sx={{ textAlign: 'center' }} style={{paddingBottom:'16px'}}>
					<div style={{display:'flex',justifyContent:'center',alignItems:'center',flexWrap:'wrap'}}>
					<SettingsIcon sx={{ color: 'black', marginRight: '2px', fontSize: '24px' }} />
					<VizHeader type={4} isBold={true}>{val}</VizHeader>
					</div>
				</CardContent>
			</Card>
		</>
	)
}